import License from './License';

export default License;